import {Component, Input, EventEmitter, Output, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {AssetService} from "./asset.service";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {SiteContactsModel} from "../workflow/site/assets-dropdowns-info-model";
import {BrokerApiContractAccountDataModel} from "../project/project.model";
import {BillFromValue} from "../bill-from/bill-from-with-region.model";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {WorkflowService} from "../workflow/workflow.service";
import {DisGqlModel} from "../dis/dis.gql-model";

@Component({
  selector: "edit-independent-service",
  templateUrl: "./edit-independent-service.template.pug",
  providers: [ConfirmDialogService],
})
export class EditIndependentServiceComponent implements OnInit {
  @Input() public disSolutions: DisGqlModel[] = [new DisGqlModel({})];
  @Input() public individual: boolean;
  @Input() public siteContract: SiteContactsModel[];
  @Input() public itsmContractAccount: BrokerApiContractAccountDataModel[];
  @Input() public billFromAccounts: BillFromValue[];

  @Output() public detectDisChanges = new EventEmitter();
  public originalDisSolutions: DisGqlModel[] = [];
  changesMade: boolean = false;

  async ngOnInit() {
    this.disSolutions.forEach((dis) => {
      dis.consolidateInvoice = !!dis.consolidateInvoice;
    });
    this.disSolutions.forEach(it => this.originalDisSolutions.push(new DisGqlModel(it)));
  }

  async remove(id, productDescription) {
    const confirm = await this.confirmDialogService.confirm(
      "Confirm",
      `Are you sure you want to remove this DIS ${productDescription} of the ${this.disSolutions[0].productNumber}?`,
    );
    if (confirm) {
      this.disSolutions = this.disSolutions.filter(it => it.id !== id);
      this.originalDisSolutions = [];
      this.disSolutions.forEach(it => this.originalDisSolutions.push(new DisGqlModel(it)));
      this.detectDisChanges.emit({
        dis: this.disSolutions,
        changes: this.changesMade,
      });
    }
  }

  async checkCurrentDisChanges() {
    const assetKeys = await Object.keys(this.disSolutions[0]);
    this.disSolutions.forEach((it) => {
      for (const key of assetKeys) {
        if (it[key] !== this.originalDisSolutions[0][key]) {
          this.changesMade = true;
          it.change = true;
        }
      }
    });
  }

  async changeDetected() {
    await this.checkCurrentDisChanges();
    this.detectDisChanges.emit({dis: this.disSolutions, changes: this.changesMade});
  }

  dateFormat(field: string) {
    if (!this.disSolutions[field]) return;
    if (this.disSolutions[field].length === 4 || this.disSolutions[field].length === 7) {
      this.disSolutions[field] = `${this.disSolutions[field]}-`;
    }
  }

  getBPID() {
    let bpid;
    const found = this.billFromAccounts.find(bf => bf.id === this.disSolutions[0].billFromBPIDId);
    if (this.billFromAccounts && found) {
      bpid = `BPID: ${found.value.billFromAccBPID}`;
    }
    return bpid;
  }

  constructor(
    private dialogService: DialogService,
    public assetService: AssetService,
    private confirmDialogService: ConfirmDialogService,
    private appSettingsService: AppSettingsService,
    private workflowService: WorkflowService,
  ) {}
}
